import { useMemo } from "react";
import {
  type CarAvailabilityCardType,
  useCarAvailabilityCard as useCoreCarAvailabilityCard,
} from "@b2bportal/core-cars";

export const useCarAvailabilityCard = (props: CarAvailabilityCardType) => {
  const { car } = props;

  const { context, handlers } = useCoreCarAvailabilityCard(props);

  return useMemo(
    () => ({
      context: {
        ...context,
        prices: {
          perDay: car.dailyCharge,
          total: car.totalCharge,
        },
      },
      handlers,
    }),
    [context, car.dailyCharge, car.totalCharge, handlers]
  );
};
